import { Canvas } from "@react-three/fiber";
import { OrbitControls, Sky } from "@react-three/drei";
import { Hub } from "./world/Hub";

export function App() {
  return (
    <Canvas
      camera={{ position: [16, 14, 16], fov: 50 }}
      shadows
      style={{ width: "100vw", height: "100vh" }}
    >
      <color attach="background" args={["#0c0e16"]} />
      <Sky sunPosition={[20, 10, 0]} />
      <ambientLight intensity={0.4} />
      <directionalLight
        position={[10, 18, 8]}
        intensity={1.1}
        castShadow
        shadow-mapSize={[2048, 2048]}
      />
      <Hub />
      <OrbitControls makeDefault target={[0, 1, 0]} />
    </Canvas>
  );
}
